import { render, staticRenderFns } from "./SignatureTab.vue?vue&type=template&id=d61d7f1c&scoped=true&"
import script from "./SignatureTab.vue?vue&type=script&lang=ts&"
export * from "./SignatureTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61d7f1c",
  null
  
)

export default component.exports